// Externe Bibliotheken
import React, { Component } from 'react';
import { NavLink } from 'react-router';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import { checkIsAllowToBookService } from '@/_helper/checkAccess';
import tracking from '@/_helper/tracking';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import HeroTeaser from '@/comp/heroTeaser';
import { BackButton } from '@/comp/backButton/backButton';

// Styles
import './emergency-contact.scss';

const params = {
    iLayer: {
        mobileNumber: {
            main: 'Bitte achten Sie auf die Richtigkeit der angegebenen Mobiltelefonnummer, um sicherzustellen, dass wir Sie vor Ort im Urlaub kontaktieren können.',
        },
    },
    errorWording: {
        firstName: 'Bitte geben Sie Ihren Vornamen ein.',
        lastName: 'Bitte geben Sie Ihren Nachnamen ein.',
        mobileNumber: 'Bitte geben Sie Ihre Handynummer ein.',
        mail: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
    },
};

class Index extends Component {
    constructor(props) {
        super(props);

        this.firstName = React.createRef();
        this.lastName = React.createRef();
        this.mobileNumber = React.createRef();
        this.mail = React.createRef();

        this.state = {
            isLoading: false,
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : {},
            bookingParams:
                storage.get('bookingData') !== null && storage.get('bookingData').bookingParams !== undefined
                    ? storage.get('bookingData').bookingParams
                    : '',

            country: 'DE',
            firstName: '',
            lastName: '',
            mobileNumber: '',
            mail: '',

            mobileNumberPrefix: {
                DE: '+49',
                AT: '+43',
                CH: '+41',
            },
            firstNameValid: false,
            lastNameValid: false,
            mobileNumberValid: false,
            mailValid: false,
            formErrors: {
                firstName: params.errorWording.firstName,
                lastName: params.errorWording.lastName,
                mobileNumber: params.errorWording.mobileNumber,
                mail: params.errorWording.mail,
            },
            error: null,
            alreadyTested: false,
            formValid: false,
            responseCase: false,
            responseCaseConfig: {
                success: false,
            },
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setEmergencyContact = this.setEmergencyContact.bind(this);
    }

    componentDidMount() {
        document.title = 'Ihre Notfall-Kontaktdaten' + window.$documentTitle;

        // not allowed to book
        if (window.$allowEmergencyContact === 'false') {
            window.location.href = '#/';
        }

        checkIsAllowToBookService('EmergencyContact');
        tracking('loaded', 'emergencyContact');

        this.setEmergencyContact();
    }

    setEmergencyContact() {
        if (Object.keys(this.state.bookingData?.data?.emergencyContactData ?? {}).length) {
            let $this = this;
            let firstName, lastName;
            let emergencyContactData = this.state.bookingData.data.emergencyContactData;

            $this.state.responseCaseConfig.success = true;

            if (emergencyContactData.name !== undefined) {
                if (emergencyContactData.name.indexOf(' ') > 0) {
                    let emergencyContactName = emergencyContactData.name.split(' ');
                    firstName = emergencyContactName[0];
                    lastName = emergencyContactName[1];
                } else {
                    firstName = emergencyContactData.name;
                }
            }

            this.setState(
                {
                    responseCase: true,
                    responseCaseConfig: $this.state.responseCaseConfig,
                    firstName: firstName !== undefined && firstName,
                    lastName: lastName !== undefined && lastName,
                    mobileNumber: emergencyContactData.phone !== undefined && emergencyContactData.phone,
                    mail: emergencyContactData.mail !== undefined && emergencyContactData.mail,
                },
                () => {
                    this.validateField('firstName', this.state.firstName);
                    this.validateField('lastName', this.state.lastName);
                    this.validateField('mobileNumber', this.state.mobileNumber);
                    this.validateField('mail', this.state.mail);
                }
            );
        }
    }

    resetTrigger(e) {
        if (this.state[e].length) {
            return (
                <div
                    className="reset-trigger"
                    onClick={(event) => {
                        this.setState({
                            [e]: '',
                            formValid: false,
                        });
                        this[e].current.focus();
                        this.validateField(e, '');
                    }}>
                    <i className="material-icons">clear</i>
                </div>
            );
        }
    }

    handleUserInput(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;

        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let valid = false;

        switch (fieldName) {
            case 'firstName':
                valid = value.length > 0;
                fieldValidationErrors.firstName = valid ? '' : params.errorWording.firstName;
                break;
            case 'lastName':
                valid = value.length > 0;
                fieldValidationErrors.lastName = valid ? '' : params.errorWording.lastName;
                break;
            case 'mobileNumber':
                let regexMobileNumber = /^\s*(\(?([\d \-)–+/(]+){9,}\)?([ .\-–/]?)(\d+))\s*$/g;
                valid = value.match(regexMobileNumber) !== null;
                fieldValidationErrors.mobileNumber = valid ? '' : params.errorWording.mobileNumber;
                break;
            case 'mail':
                let regexMail =
                    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
                valid = value.match(regexMail) !== null;
                fieldValidationErrors.mail = valid ? '' : params.errorWording.mail;
                break;
            default:
                break;
        }

        this.setState(
            {
                formErrors: fieldValidationErrors,
                [fieldName + 'Valid']: valid,
            },
            this.validateForm
        );
    }

    validateForm() {
        this.setState({
            formValid:
                this.state.firstNameValid &&
                this.state.lastNameValid &&
                this.state.mobileNumberValid &&
                this.state.mailValid,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        let $this = this;

        this.setState({
            error: false,
            alreadyTested: true,
        });

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs
            let fieldValidationErrors = this.state.formErrors;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }

        // form is valid!
        const sendData = {
            requestType: 'bookingData',
            clientId: 'customerarea',
            requestSource: 'AurumTours-Customerarea',
            bookingId: storage.get('bookingNumber'),
            action: 'sendEmergencyContact',
            hash: storage.get('access_token'),
            data: {
                firstName: this.state.firstName.trim(),
                lastName: this.state.lastName.trim(),
                phone: this.state.mobileNumber,
                mail: this.state.mail,
            },
        };

        this.setState({
            formVacancy: true,
        });

        axios({
            url: window.$serviceUrl + '/bookingData?token=' + window.$token,
            method: 'POST',
            data: sendData,
        })
            .then((response) => response)
            .then(function (response) {
                if (response.data.data.statusCode === 200) {
                    tracking('success', 'emergencyContact');
                    if (!window.$affiliate) {
                        window.$gtmTracking.gtag('event', 'page_success', { page: 'emergencyContact' });
                    }

                    let responseCaseConfig = $this.state.responseCaseConfig;
                    responseCaseConfig.success = true;

                    // set
                    $this.setState({
                        formVacancy: false,
                        responseCase: true,
                        responseCaseConfig: responseCaseConfig,
                    });

                    $this.state.bookingData.data.emergencyContactData = {
                        mail: $this.state.mail,
                        name: $this.state.firstName.trim() + ' ' + $this.state.lastName.trim(),
                        phone: $this.state.mobileNumber,
                    };
                    storage.set('bookingData', $this.state.bookingData);
                } else {
                    $this.setState({
                        formVacancy: false,
                        responseCase: true,
                    });

                    // scroll top
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
            })
            .catch((error) => {
                $this.setState({
                    formVacancy: false,
                });

                // scroll top
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
    }

    iLayer(t, c) {
        let getILayerInformations = params.iLayer[t];

        if (getILayerInformations !== undefined && getILayerInformations[c] !== undefined) {
            return (
                <div className="info-layer">
                    <i className="material-icons">info</i>
                    <div className="overlay">
                        <div className="corner"></div>
                        <div className="content">
                            <p dangerouslySetInnerHTML={{ __html: getILayerInformations[c] }}></p>
                        </div>
                    </div>
                </div>
            );
        }
    }

    responseCase() {
        let config = this.state.responseCaseConfig;

        return (
            <div className="response-case">
                <div className="intro row">
                    <div className={'icon ' + (config.success ? 'success' : 'error')}></div>
                    <div className="content">
                        <h1 className="main-headline col">{config.success ? 'Ihre Notfallkontaktdaten' : 'Oops!'}</h1>
                    </div>
                </div>
                <div className="next-steps sec">
                    <div className="content">
                        {config.success ? (
                            <div>
                                <p>Die folgenden Kontaktdaten haben Sie für Notfälle bei uns hinterlegt.</p>
                                <br />
                                {this.state.firstName.length > 0 ? <p>Vorname : {this.state.firstName}</p> : ''}
                                {this.state.lastName.length > 0 ? <p>Nachname : {this.state.lastName}</p> : ''}
                                {this.state.mobileNumber.length > 0 ? (
                                    <p>Handynummer : {this.state.mobileNumber}</p>
                                ) : (
                                    ''
                                )}
                                {this.state.mail.length > 0 ? <p>E-Mail : {this.state.mail}</p> : ''}
                            </div>
                        ) : (
                            <div>
                                <p>Da ist was schiefgelaufen!</p>
                                <br />
                                <p>
                                    Leider ist ein Fehler bei der Übermittlung Ihrer Daten aufgetreten. Bitte prüfen Sie
                                    Ihre Angaben und versuchen Sie es zu einem späteren Zeitpunkt erneut.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="user-action">
                    <BackButton class="col" to="/buchung-verwalten" />

                    <div
                        className="button link valid"
                        onClick={() => {
                            this.setState({ responseCase: false });
                        }}>
                        Kontaktdaten ändern<i className="material-icons">arrow_forward</i>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="page-emergency-contact">
                <Header contactLayerMail="digitale.reiseleitung@aurumtours.de" />

                <HeroTeaser size={this.state.success ? 'full' : ''} />

                <div className="content-wrapper">
                    {this.state.responseCase && this.responseCase()}

                    {!this.state.responseCase && (
                        <div>
                            <div className="intro row">
                                <h1 className="main-headline col">Ihre Notfall-Kontaktdaten</h1>
                            </div>

                            <p>
                                Wir möchten Ihnen auch in unvorhersehbaren Ausnahmesituationen den besten Service
                                bieten.
                                <br />
                                Die Corona-Krise hat gezeigt, wie wichtig es ist, dass wir unsere Kunden schnell und
                                ohne Umwege vor Ort im Urlaub erreichen können.
                                <br />
                                Wir versichern Ihnen, dass wir Sie nur im Notfall kontaktieren und Ihre Daten nicht für
                                Werbezwecke verwenden.
                            </p>

                            <p className="last">
                                Hier haben Sie die Möglichkeit, einen Kontakt zu hinterlegen, unter dem wir Sie während
                                der Reise erreichen können.
                            </p>

                            {/* FORM */}
                            <form
                                className={'txtL ' + (this.state.formVacancy ? 'validate' : '')}
                                autoComplete="off"
                                onSubmit={this.handleSubmit}
                                method="post"
                                noValidate=""
                                onChange={() => tracking('interaction', 'emergencyContact')}>
                                <div className="entry">
                                    <div className="row">
                                        <div className="first">
                                            <label htmlFor={'firstName'}>Vorname</label>
                                        </div>
                                        <div className="last">
                                            <input
                                                id={'firstName'}
                                                name={'firstName'}
                                                className="with-border"
                                                ref={this.firstName}
                                                type="text"
                                                placeholder="Ihr Vorname"
                                                value={this.state.firstName}
                                                onChange={(event) => {
                                                    this.handleUserInput(event);
                                                }}
                                            />

                                            {this.resetTrigger('firstName')}
                                        </div>

                                        {this.state.alreadyTested && this.state.formErrors.firstName !== true && (
                                            <div className="error">{this.state.formErrors.firstName}</div>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="first">
                                            <label htmlFor={'lastName'}>Nachname</label>
                                        </div>
                                        <div className="last">
                                            <input
                                                id={'lastName'}
                                                name={'lastName'}
                                                className="with-border"
                                                ref={this.lastName}
                                                type="text"
                                                placeholder="Ihr Nachname"
                                                value={this.state.lastName}
                                                onChange={(event) => {
                                                    this.handleUserInput(event);
                                                }}
                                            />

                                            {this.resetTrigger('lastName')}
                                        </div>

                                        {this.state.alreadyTested && this.state.formErrors.lastName !== true && (
                                            <div className="error">{this.state.formErrors.lastName}</div>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="first">
                                            <label htmlFor={'mobileNumber'}>Handynummer</label>
                                        </div>
                                        <div className="last">
                                            <div className="select-cnt">
                                                <select
                                                    id={'country'}
                                                    name="country"
                                                    value={this.state.country}
                                                    onChange={(event) => {
                                                        this.handleUserInput(event);
                                                    }}>
                                                    <option value="DE">DE</option>
                                                    <option value="AT">AT</option>
                                                    <option value="CH">CH</option>
                                                </select>
                                            </div>

                                            <input
                                                id={'mobileNumber'}
                                                name={'mobileNumber'}
                                                className="with-border"
                                                ref={this.mobileNumber}
                                                type="text"
                                                placeholder="0160 111111"
                                                value={this.state.mobileNumber}
                                                onChange={(event) => {
                                                    this.handleUserInput(event);
                                                }}
                                            />

                                            {this.resetTrigger('mobileNumber')}

                                            {this.iLayer('mobileNumber', 'main')}
                                        </div>

                                        {this.state.alreadyTested && this.state.formErrors.mobileNumber !== true && (
                                            <div className="error">{this.state.formErrors.mobileNumber}</div>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="first">
                                            <label htmlFor={'mail'}>E-Mail</label>
                                        </div>
                                        <div className="last">
                                            <input
                                                id={'mail'}
                                                name={'mail'}
                                                className="with-border"
                                                ref={this.mail}
                                                type="email"
                                                placeholder="Ihre E-Mail-Adresse"
                                                value={this.state.mail}
                                                onChange={(event) => {
                                                    this.handleUserInput(event);
                                                }}
                                            />

                                            {this.resetTrigger('mail')}
                                        </div>

                                        {this.state.alreadyTested && this.state.formErrors.mail !== true && (
                                            <div className="error">{this.state.formErrors.mail}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="small-print">
                                    <p>
                                        Durch das Absenden Ihrer Daten sind Sie damit einverstanden, dass wir Sie zu
                                        dringlichen Anliegen bezüglich Ihrer gebuchten Reise kontaktieren. Sie sind
                                        außerdem damit einverstanden, dass wir Ihre Daten nach Datenschutzrichtlinien
                                        speichern und verarbeiten.
                                    </p>
                                    <p>
                                        Unsere vollständigen{' '}
                                        <NavLink to="/datenschutz" target="_blank">
                                            Datenschutzhinweise
                                        </NavLink>{' '}
                                        und{' '}
                                        <a
                                            href={`${window.$website}/unternehmen/agb`}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            AGB
                                        </a>{' '}
                                        finden Sie auf unserer{' '}
                                        <a href={window.$website} target="_blank" rel="noopener noreferrer">
                                            Webseite
                                        </a>
                                        .
                                    </p>
                                </div>

                                <div className="user-action">
                                    <BackButton class="col" to="/buchung-verwalten" />

                                    <button
                                        className={
                                            'col ' +
                                            (this.state.formValid ? 'valid ' : 'invalid ') +
                                            (this.state.formVacancy ? 'validate' : '')
                                        }
                                        type="submit"
                                        // disabled={!this.state.formValid}
                                    >
                                        {this.state.formVacancy ? (
                                            <span>Daten werden übermittelt ...</span>
                                        ) : (
                                            <span>Kontaktdaten übermitteln</span>
                                        )}

                                        <i className="material-icons">arrow_forward</i>

                                        <span className="loader"></span>
                                    </button>
                                </div>

                                {this.state.error === true && (
                                    <div className={'error txtR'}>{window.$content.errorText}</div>
                                )}

                                {this.state.error !== true &&
                                    Array.isArray(this.state.error) &&
                                    this.state.error.map((e, i) => {
                                        return (
                                            <div key={i} className={'error txtR'}>
                                                {e}
                                            </div>
                                        );
                                    })}
                            </form>
                        </div>
                    )}
                </div>

                <Footer />
            </div>
        );
    }
}

export default Index;
